import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '../http/server_result';

// export interface RootState {
//   ubic: string;
// }

export interface ContextState {
  actor: any;
  token: any;

  pushRegistrationComplete: boolean;

  pushToken: string | null;
  pushRistrationError: any;

  recivedPushMessages: any[];
  performedPushMessages: any[];

  counters: any;
}

export const state: ContextState = {
  actor: null,
  token: null,

  pushRegistrationComplete: true,

  pushToken: null,
  pushRistrationError: null,

  recivedPushMessages: [],
  performedPushMessages: [],

  counters: {
    countAll: 0, countUnread: 0
  }
};

const LOAD_NOTIFICATIONS_COUNT = 'LOAD_NOTIFICATIONS_COUNT';
const LOAD_NOTIFICATIONS_UNREAD_COUNT = 'LOAD_NOTIFICATIONS_UNREAD_COUNT';

export const actions: ActionTree<ContextState, RootState> = {
  prepare({ commit, dispatch }, params) {
    if (params) {
      commit('SET_IDENTITY', params);
      // dispatch('startNotifiactionLoop');
    }
  },

  login({ state, commit, dispatch }, params) {
    // console.log('state.pushToken');
    // console.log(state.pushToken)

    return new Promise((resolve, reject) => {
      (this as any)._vm.$http.post(`/api/v1/tokens`, {
        ...params,
        app_id: '8k-j5e7n_hwIBvBMhoOQGhzlkBJm9z8HpY2zpi6rtzsLP7k0S-kV7tDp1T0LQjkcduQ'
      })
      .then((loginResponse: any) => {
        // tslint:disable-next-line:no-console
        console.log('loginResponse', loginResponse.data);

        if (loginResponse.data.status === 'success') {
          // status: "success"
          // result:
          //   actor:
          //     document: {...}
          //     roles: ["admin"]
          //     schema: {fields: Array(13), meta: {…}}
          //   token: "BBU3AaihqQYPb0GteIzo0K5ALbJkaGIifHr3xyWmuLimJFq2CNUr8kN3nnzX

          commit('SET_IDENTITY', loginResponse.data.result);

          // (this as any)._vm.$http.post(`/api/v1/push-fcm`, {
          //   fcm_token: state.pushToken
          // }, {
          //   headers: {
          //     'Content-Type': 'application/json',
          //     'Authorization': state.token
          //   },
          // }).then((response: any) => {
          //   console.log('subscription save');
          // })
          // .catch((errror: any) => {
          //   console.log('subscription not save');
          //   console.error(errror);
          // });

          // dispatch('startNotifiactionLoop');

          resolve();
        } else {
          // status "failure"
          // result: "incorrect login or password"
          reject(loginResponse.data.result);
        }
      });

    });
  },

  logout({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      // (this as any)._vm.$http.delete(`/api/v1/push-fcm`, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': state.token
      //   },
      // }).then((response: any) => {
      //   console.log('subscription delete');
      //
      //   commit('SET_IDENTITY', {
      //     actor: null,
      //     token: null
      //   });
      //
      // })
      // .catch((errror: any) => {
        // console.log('subscription not delete');
        // console.error(errror);

        commit('SET_IDENTITY', {
          actor: null,
          token: null
        });
      // });

    })
  },

  pushRegistration({ commit }) {
    commit('PUSH_REG_START');
  },

  pushRegistrationSuccess({ commit }, token) {
    commit('PUSH_REG_SUCCESS', token);
  },

  pushRegistrationError({ commit }, error) {
    commit('PUSH_REG_ERROR', error);
  },

  pushReceived({ commit }, notification) {
    commit('PUSH_MESSAGE_RECIVE', notification);
  },

  pushActionPerformed({ commit }, notification) {
    commit('PUSH_MESSAGE_PERFORM', notification);
  },

  startNotifiactionLoop({ state, commit }) {
    const vm = (this as any)._vm;

    const getStatsFromServer = () => {
      if (!state.actor) {
        return;
      }

      vm.$db([
        vm.$q(LOAD_NOTIFICATIONS_COUNT)
          .select()
          .from('notifications')
          .fileds$((_: any) => {
            return {
              count_all: {$count: `notifications.id`}
            };
          })
          .group(['notifications.actor_id'])
          .where((_: any) => _.eq('notifications.actor_id', _.const(state.actor.document.id))),
  
        vm.$q(LOAD_NOTIFICATIONS_UNREAD_COUNT)
          .select()
          .from('notifications')
          .fileds$((_: any) => {
            return {
              count_unread: {$count: `notifications.id`}
            };
          })
          .group(['notifications.actor_id'])
          .where((_: any) => _.and([
            _.eq('notifications.actor_id', _.const(state.actor.document.id)),
            _.eq('notifications.is_read', _.const(false))
          ]))
      ]).then((response: ServerResult) => {
        const countAllDocs = response.getOperation(LOAD_NOTIFICATIONS_COUNT).getContent().documents;
        const countUnreadDocs = response.getOperation(LOAD_NOTIFICATIONS_UNREAD_COUNT).getContent().documents;

        const countAll = countAllDocs.length > 0 ? countAllDocs[0].count_all : 0;
        const countUnread = countUnreadDocs.length > 0 ? countUnreadDocs[0].count_unread : 0;

        commit('UPDATE_COUNTERS', {
          countAll, countUnread
        });
      });
    };

    getStatsFromServer();
    setInterval(getStatsFromServer, 10000)
  }
};

export const mutations: MutationTree<ContextState> = {
  SET_IDENTITY(state: any, payload) {
    state.actor = payload.actor;
    state.token = payload.token;
  },

  UPDATE_COUNTERS(state: any, payload: any) {
    state.counters = payload;
  },

  PUSH_REG_START(state: any) {
    state.pushRegistrationComplete = false;
  },

  PUSH_REG_SUCCESS(state: any, token: string) {
    state.pushRegistrationComplete = true;
    state.pushToken = token;
  },

  PUSH_REG_ERROR(state: any, error) {
    state.pushRegistrationComplete = true;
    state.pushRistrationError = error;
  },

  PUSH_MESSAGE_RECIVE(state: any, message: string) {
    state.recivedPushMessages = [
      message,
      ...state.recivedPushMessages
    ]
  },

  PUSH_MESSAGE_PERFORM(state: any, message: string) {
    state.performedPushMessages = [
      message,
      ...state.performedPushMessages
    ]
  }
  
};


export const getters: GetterTree<ContextState, RootState> = {
  isAuthenticated: (state: any) => {
    return !!state.token;
  },
  isAdmin: (state: any) => {
    return state.actor.roles.indexOf('admin') > -1;
  },
  isController: (state: any) => {
    return state.actor.roles.indexOf('controller') > -1;
  }
};

const namespaced = true;

export const ubic: Module<ContextState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters
};
